import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { shuffle } from '~/utils'

const VARIABLES = ['a', 'b', 'c', 'x', 'y', 'z']
const SIGNS = ['+', '-', '+', '-']
const RANGE_DATA: RangeDataModel = {
  1: {
    totalTerms: 2,
    totalAlgebraicTerms: 1,
    isAnswerPositive: true,
    maxHistoryLength: 10,
  },
  2: {
    totalTerms: 3,
    totalAlgebraicTerms: 2,
    isAnswerPositive: true,
    maxHistoryLength: 20,
  },
  3: {
    totalTerms: 3,
    totalAlgebraicTerms: 2,
    isAnswerPositive: false,
    maxHistoryLength: 20,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  totalTerms: number
  totalAlgebraicTerms: number
  isAnswerPositive: boolean
  maxHistoryLength: number
}

export interface EquationPartsModel {
  integer: number | string
  variable?: string
  sign?: string
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ActivityDataModel {
  equationString: string
  variableValue: number
  variable: string
  answer: number
  maxHistoryLength: number
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateValueVariableActivityData(difficultyLevel: number, taskHistory: string[]): ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const algebraicEquationParts: EquationPartsModel[] = []
  const nonAlgebraicEquationParts: EquationPartsModel[] = []
  const variable = VARIABLES[getRandomInt(0, VARIABLES.length - 1)]
  const variableValue = getRandomInt(1, 9)
  const signs = shuffle(SIGNS)
  // eslint-disable-next-line
  for (let i = 0; i < range.totalTerms - range.totalAlgebraicTerms; i++) {
    nonAlgebraicEquationParts[i] = {
      integer: getRandomInt(1, 9),
      sign: signs[i],
    }
  }
  // eslint-disable-next-line
  for (let i = 0; i < range.totalAlgebraicTerms; i++) {
    algebraicEquationParts[i] = {
      integer: 1,
      variable,
      sign: signs[range.totalTerms - range.totalAlgebraicTerms + i],
    }
  }
  const equationParts = [...algebraicEquationParts, ...nonAlgebraicEquationParts]
  equationParts[0].sign = undefined
  let equationString = ''
  let evalString = ''
  equationParts.forEach((item) => {
    equationString += `${item.sign ? ` ${item.sign}` : ''} ${item.integer > 1 || !item.variable ? item.integer : ''}${
      item.variable ? `<i>${item.variable}</i>` : ''
    }`
    evalString += `${item.sign ? ` ${item.sign}` : ''} ${
      parseInt(item.integer.toString()) * (item.variable ? variableValue : 1)
    }`
  })
  evalString = evalString.replaceAll('×', '*')
  let answer = eval(evalString)
  // for negative answer
  if (answer < 0 && range.isAnswerPositive) {
    equationString = equationString.replaceAll('-', '+')
    evalString = evalString.replaceAll('-', '+')
    answer = eval(evalString)
  }
  if (taskHistory.includes(equationString)) return generateValueVariableActivityData(difficultyLevel, taskHistory)

  return { equationString, answer, variableValue, variable, maxHistoryLength: range.maxHistoryLength }
}
